import type { Owner, QuoteOwner } from '@paintscout/api'

export function convertToOwner({ owner }: { owner: QuoteOwner }): Owner {
  return {
    ...owner,
    __typename: 'Owner'
  }
}
